// extracted by mini-css-extract-plugin
export default {"button":"sellerdiscountblock1_button__WwEUt","box":"sellerdiscountblock1_box__l1MKw","block":"sellerdiscountblock1_block__8kfzs"};